<div class="form-group Flexbox">
    <input id="ifu1" class="admin-ifu ng-pristine ng-untouched ng-valid ng-empty" name="ifu"  (change)="upload($event.target.files)" type="file">
    <label class="btnBoarder btn-default primary__button" for="ifu1">Choose a file</label>
    <input  class="admin-ifu-value Auto_PrivacyNotes ng-pristine ng-untouched ng-valid ng-empty" [ngModel]="fileName"  disabled="">
</div>

<gen-dynamic-form class="patient-details-wrapper" [formConfig]="inputConfig"
                  [listenToDataChange]="listenToDataChange"
                  [submitted]="widgetFormInstanceSubmitted"
                  [popupMode]="true"
                  (formChange)="formupdate($event.form)"></gen-dynamic-form>
